import Vue from 'vue';
import ViewUI from 'view-design';
import App from './App.vue';
import route from './route';
import 'view-design/dist/styles/iview.css';
import plTable from 'pl-table'
import 'pl-table/themes/index.css' // 引入样式（必须引入)，请查看webpack是否配置了url-loader对woff，ttf文件的引用,不配置会报错哦
import 'pl-table/themes/plTableStyle.css'

Vue.use(ViewUI);
Vue.use(plTable);
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router: route
}).$mount('#app')
